import React from "react";
import CELogo from "./assets/ABRIDGED_Color.png";
import { Button, makeStyles, Paper } from "@material-ui/core";
import { authUrl } from "./helpers/baseUrl.js";
import axios from "axios";
axios.defaults.withCredentials = true;
const useStyles = makeStyles((theme) => ({
  ceBtn: {
    backgroundColor: "#F0BA1B",
    color: "#fff",
    fontSize: "1rem",
    margin: "2rem auto",
    minWidth: "300px",
    display: "block",
    [theme.breakpoints.only("xs")]: {
      minWidth: "90%",
    },
    "&:hover": {
      backgroundColor: "#D6A718",
    },
  },
  adpBtn: {
    backgroundColor: "#FFF",
    border: "2px solid #d0271d",
    color: "#d0271d",
    fontSize: "1rem",
    fontWeight: "bold",
    margin: "2rem auto",
    minWidth: "300px",
    display: "block",
    [theme.breakpoints.only("xs")]: {
      minWidth: "90%",
    },
    "&:hover": {
      backgroundColor: "#FFF",
      border: "2px solid #941c15",
      color: "#941c15",
    },
  },
  image: {
    margin: "0.75rem 0",
    width: "200px",
  },
  root: {
    backgroundColor: "#009CBF",
    display: "flex",
    height: "100vh",
  },
  paper: {
    textAlign: "center",
    padding: "2rem",
    maxWidth: "60%",
    margin: "10% auto",
    [theme.breakpoints.only("xs")]: {
      borderRadius: "0px",
      margin: "0",
      padding: "0",
      minWidth: "100vw",
      height: "100vh",
    },
  },
}));

function App() {
  const classes = useStyles();

  const url = `${authUrl}/initLogin?callback_uri=`;

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const callbackUri = urlParams.get("callback_uri");

  // console.log(callbackUri);
  return (
    <div className={classes.root}>
      <Paper elevation={4} className={classes.paper}>
        <img className={classes.image} src={CELogo} alt="Abridged tech" />

        <form
          action={`https://go.callexperts.com/abridgedtech/attendancetracker`}
        >
          {/* <input type="hidden" name="callback_uri" value={callbackUri} /> */}
          <Button
            variant="contained"
            className={classes.ceBtn}
            type="submit"
            // name="provider"
            // value={"cognito"}
          >
            Log in through attendance tracker
          </Button>
          {/* <Button
            variant="outlined"
            className={classes.adpBtn}
            type="submit"
            name="provider"
            value={"adp"}
            disabled
          >
            Login through ADP
          </Button> */}
        </form>
      </Paper>
    </div>
  );
}

export default App;
